import { EmbedConfig, MemberInterface, TakeoverEventPayload, TakeoverEventType } from "@swivl-mono/types";
import React, { Component } from "react";

import { Config } from "../../../../Config/Config";
import { ListItemData } from "../../ListItem";
import "./TakeoverEvent.css";

export interface TakeoverEventProps {
  item: ListItemData;
}

export class TakeoverEvent extends React.Component<TakeoverEventProps> {
  render() {
    const config = Config;
    const payload = (this.props.item as any).message.payload as TakeoverEventPayload;
    const member: MemberInterface | undefined = payload.member;
    var avatarURL, text;
    if (payload.type === TakeoverEventType.TAKEOVER_STARTED) {
      avatarURL = member?.agentAvatarURL || "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      text = member?.agentName ? member?.agentName + " has entered the conversation" : "An agent has entered the conversation";
    } else {
      avatarURL = config?.avatarURL ? config.avatarURL : "https://swivl-cdn.s3-us-west-1.amazonaws.com/avatar-generic.png";
      const botName = config?.botName ? config.botName : "the bot";
      text = "You're now chatting with " + botName;
    }

    return (
      <div className="scc-TakeoverEvent">
        {/* keep critical image layout inline as an embed fallback if host css overrides utilities */}
        <div className="scc-TakeoverEvent-avatar" style={{ width: 20, height: 20 }}>
          <img className="scc-TakeoverEvent-avatarImage" src={avatarURL} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
        <div className="swivl-timestamp text-sm leading-4 text-grey-600">{text}</div>
      </div>
    );
  }
}
